import {configureStore} from '@reduxjs/toolkit';

import {BillableUnitsReducer} from '../features/billable-units/reducers';
import {BillingProvidersReducer} from '../features/billing-providers/reducers';
import {CustomersReducer} from '../features/customers/reducers';
import {CustomerSubscriptionsReducer} from '../features/customer-subscriptions/reducers';
import {InvoicesReducer} from '../features/invoices/reducers';
import {MeterAssignmentsReducer} from '../features/meter-assignments/reducers';
import {MetersReducer} from '../features/meters/reducers';
import {OrdersReducer} from '../features/orders/reducers';
import {PaymentProfilesReducer} from '../features/payment-profiles/reducers';
import {PricesReducer} from '../features/prices/reducers';
import {ProductFeaturesReducer} from '../features/product-features/reducers';
import {ProductLineItemsReducer} from '../features/product-line-items/reducers';
import {ProductsReducer} from '../features/products/reducers';
import {ProviderMappingsReducer} from '../features/provider-mappings/reducers';
import {RatePlansReducer} from '../features/rate-plans/reducers';
import {SubscriptionItemsReducer} from '../features/subscription-items/reducers';

// Row selection state only (FNP-951). Records are React Query's job — this store
// holds which rows the operator has checked, nothing else. Do not add record
// caches here.
const reducers = {
    'billable-units': BillableUnitsReducer,
    'billing-providers': BillingProvidersReducer,
    'customers': CustomersReducer,
    'customer-subscriptions': CustomerSubscriptionsReducer,
    'invoices': InvoicesReducer,
    'meter-assignments': MeterAssignmentsReducer,
    'meters': MetersReducer,
    'orders': OrdersReducer,
    'payment-profiles': PaymentProfilesReducer,
    'prices': PricesReducer,
    'product-features': ProductFeaturesReducer,
    'product-line-items': ProductLineItemsReducer,
    'products': ProductsReducer,
    'provider-mappings': ProviderMappingsReducer,
    'rate-plans': RatePlansReducer,
    'subscription-items': SubscriptionItemsReducer,
};

export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
